// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"65a14859","233":"720c2da9","326":"3ac4c16a","383":"9343d814","641":"c4de9b72"}[chunkId] + ".chunk.css";
};